var t = /* @__PURE__ */ ((r) => (r.HORIZONTAL = "horizontal", r.VERTICAL = "vertical", r))(t || {});
export {
  t as REFERENCE_LINE_ORIENTATION
};
